import intersectionBy from 'lodash/intersectionBy';
import type { TransformedRole, TransformRolesOnSubmit } from '../../common/types.tsx';
import type { CurrentSelectedRoles, OnRoleChanged, SelectedRoles } from './types.tsx';

export const getOptionLabel = (role: TransformedRole): string => role.name;

export const getOptionValue = (role: TransformedRole): string => role.roleId;

export const convertRolesToCurrentRole = (
	selectedRoles: CurrentSelectedRoles,
	allRoles: TransformedRole[],
): TransformedRole[] => {
	const transformedCurrentRoles: Array<TransformedRole> = [];
	selectedRoles.forEach((restriction) => {
		const matchedRestriction = allRoles.find((role) => role.roleId === restriction.roleId);
		matchedRestriction && transformedCurrentRoles.push(matchedRestriction);
	});
	return transformedCurrentRoles;
};

export const transformRolesToArrayIfNull = (
	roles: TransformedRole[] | null,
	onChange: OnRoleChanged,
): void => onChange(roles || []);

export const mapRoleToRestrictionValue = (roles: SelectedRoles[]): TransformRolesOnSubmit => ({
	projectrole: roles.map(({ roleId }) => ({
		restrictionValue: roleId,
	})),
});

export const isUserRoleIncludedInRestrictedRoles = (
	selectedRoles: CurrentSelectedRoles,
	rolesWithCurrentUserRole: TransformedRole[],
): boolean => {
	// no restrictions applied
	if (selectedRoles.length === 0) {
		return true;
	}
	const selectedRoleWithCurrentUserRoles = intersectionBy(
		selectedRoles,
		rolesWithCurrentUserRole,
		'roleId',
	);
	return Boolean(selectedRoleWithCurrentUserRoles.length);
};
